
export const REQUEST_ADDNEWCLIENT= 'REQUEST_ADDNEWCLIENT';
export const ADDNEWCLIENT_RECEIVED = 'ADDNEWCLIENT_RECEIVED';